import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";

@Injectable({providedIn: 'root'})
export class PageTitleRequestService {
  constructor(
    private http: HttpClient,
  ) {
  }

  getNavBarTitleData(params: any): Observable<any> {
    const lang = document.documentElement.lang || 'ru-RU'; // fallback, если вдруг пусто

    const headers = new HttpHeaders({
      'X-Language': lang
    });

    return this.http.post(`/new/nav-bar-title-data`, { ...params }, { headers });
  }
}
